<template>
  <div class="nearest-shop" v-if="closest">
    {{ closest }}
    <DropdownMenu
      class="nearest-shop--actions-menu"
      :triggerLabel="$t('ShopActions')"
      :triggerClasses="['button', 'is-text', 'is-small']"
      @dropdownOpened="refreshNearShops"
    >
      <a
        class="dropdown-item nearest-shop--actions-menu--prefer-button"
        v-for="shop in nearEnoughShops"
        @click="markShopPreferred(shop)"
        :key="shop._id"
        >{{ shop.name }}</a
      >
    </DropdownMenu>
  </div>
</template>
<script>
import Vue from "vue";
import { Shop } from "@/models/Shop";
import { haversineDistance } from "@/models/Geolocation";
import DropdownMenu from "@/components/DropdownMenu.vue";
const _ = require("lodash");

export default Vue.extend({
  name: "NearestShop",
  props: { position: { type: Object, required: true } },
  computed: {
    nearEnoughShops() {
      const sortedByPreferenceAndDistance = _.sortBy(
        this.$store.state.shops,
        (shop) => (shop.isPreferred ? 0 : 1),
        (shop) => {
          return haversineDistance(this.position, shop.position);
        }
      );

      const nearEnough = sortedByPreferenceAndDistance.filter((shop) => {
        return haversineDistance(this.position, shop.position) <= 50;
      });

      return nearEnough;
    },
    closest() {
      const shop = Shop.matchByPosition(this.$store.state.shops, this.position);
      if (!shop) {
        return null;
      }
      return shop.name;
    },
  },
  methods: {
    refreshNearShops() {
      this.$store.dispatch("loadNearShops", this.position);
    },
    markShopPreferred(shop) {
      const competingShops = this.nearEnoughShops.filter(
        (nearShop) => nearShop !== shop
      );

      this.$store.dispatch("markShopPreferred", {
        prefer: shop,
        unprefer: competingShops,
      });
    },
  },
  watch: {
    closest: {
      handler(newValue) {
        if (!newValue) {
          this.$store.dispatch("loadNearShops", this.position);
        }
      },
      immediate: true,
    },
  },
  components: {
    DropdownMenu,
  },
});
</script>
<style>
.nearest-shop--actions-menu {
}
a.nearest-shop--actions-menu--prefer-button {
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
}
.nearest-shop--actions-menu .dropdown-trigger .button {
  height: auto;
  padding: 0;
  color: #777;
}
</style>
<i18n>
{
  "en": {
    "ShopActions": "Wrong?"
  },
  "de": {
    "ShopActions": "Falsch?"
  }
}
</i18n>
